import Service from '@/helpers/factoryTourService'

export default {

    schedules() {
        return Service().get('factory-tour/schedules');
    },
    register(params) {
        return Service().post('factory-tour/register', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
}
